import { render, staticRenderFns } from "./JcomSettingList.vue?vue&type=template&id=17a44640"
import script from "./JcomSettingList.vue?vue&type=script&lang=js"
export * from "./JcomSettingList.vue?vue&type=script&lang=js"
import style0 from "./JcomSettingList.vue?vue&type=style&index=0&id=17a44640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports